// extracted by mini-css-extract-plugin
export default {"section-container":"SectionsContainer_section-container__e6tMl"};